<div class="overlay-panel"
      [style.display]="visible ? 'block' : 'none'"
      (click)="onPanelClick($event)"
      [@panelState]="visible ? 'visible' : 'hidden'">
  <div class="overlay-panel-content">
    <ng-content></ng-content>
  </div>
  <a [attr.data-btnId]="getElementId('close')"  href="#" *ngIf="showCloseIcon" class="overlay-panel-close" (click)="onCloseClick($event)">
    <span class="fa fa-fw fa-close"></span>
  </a>
</div>
